<div class="content">
  <span class="mat-title">Processos seletivo</span>
  <div class="controls" style="gap:10px">
    <button color="primary" mat-raised-button (click)="newProcessList()">
      Novo processo seletivo
    </button>
    <button color="warn" mat-raised-button (click)="unarchiveProcessList()">
      Processos seletivos arquivados
    </button>
  </div>

  <div class="empty-content" *ngIf="processLists?.length === 0 && !submiting">
    <span class="mat-body-2">Nenhum processo seletivo encontrado</span>
  </div>

  <mat-accordion>
    <ng-container *ngFor="let processList of processLists; let i = index">
      <mat-expansion-panel [expanded]="i == ProcessIndex" (closed)="ProcessIndex = -1; onPanelClosed()"
        (opened)="ProcessIndex = i; VerifyQtdinProcess(processList); getTotalCandidatesToApproval(processList.id); onPanelOpened(processList)"
        [disabled]="currentLead !== 'ACTIVE' && currentLead !== 'TRIAL'">
        <mat-expansion-panel-header>
          <mat-panel-title class="process-title">
            Processo seletivo {{ processList.name }}
          </mat-panel-title>
          <mat-panel-description>
            {{ processList.created_at | date : "dd/MM/yyyy hh:mm" }}
            <span style="padding-left: 10%">
              {{ getProcessListStatus(processList) }}
              <span class="custom-badge" *ngIf="processList.candidates > 0">{{ processList.candidatesPending }} /
                {{ processList.candidates }} candidatos</span>
            </span>
            <span style="padding-left: 2%;">
              <span class="custom-badge">
                {{ vacanciesProcess[processList.id] || 0 }} vaga{{ vacanciesProcess[processList.id] !== 1 ? 's' : '' }}
                {{ vacanciesProcess[processList.id] === 1 ? 'disponível' : 'disponíveis' }} /
                {{ hiredProcess[processList.id] || 0 }} contratado{{ hiredProcess[processList.id] > 1 ? 's' : '' }}
              </span>
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div>
          <mat-divider></mat-divider>
          <div style="padding-top: 10px; padding-bottom: 10px">
            <div class="row" style="margin-bottom: 10px;" *ngIf="isSmallScreen$ | async">
              <span class="custom-badge">
                {{ vacanciesProcess[processList.id] || 0 }} vaga{{ vacanciesProcess[processList.id] !== 1 ? 's' : '' }}
                {{ vacanciesProcess[processList.id] === 1 ? 'disponível' : 'disponíveis' }} /
                {{ hiredProcess[processList.id] || 0 }} contratado{{ hiredProcess[processList.id] > 1 ? 's' : '' }}
              </span>
            </div>
            <button mat-stroked-button *ngIf="isSmallScreen$ | async" color="primary"
              (click)="openProcessList(processList)">
              Ver detalhes
            </button>
            <!-- *ngIf="['new', 'pending'].includes(processList.status)" -->
            <button color="warn" mat-stroked-button [ngStyle]="
                (isSmallScreen$ | async) ? { 'margin-left': '10px' } : {}
              " (click)="ArchiveProcessList($event, processList)">
              <mat-icon>inventory_2</mat-icon>
              <span *ngIf="!(isSmallScreen$ | async)">Arquivar processo seletivo</span>
            </button>
            <!-- *ngIf="['new', 'pending'].includes(processList.status)" -->
            <button style="margin-left: 10px" color="primary" mat-stroked-button
              (click)="editeProcessList(processList)">
              <mat-icon>edit</mat-icon>
              <span *ngIf="!(isSmallScreen$ | async)">Editar processo seletivo</span>
            </button>
            <button style="margin-left: 10px" color="warn" mat-raised-button [ngStyle]="
                (isSmallScreen$ | async) ? { 'margin-top': '12px', 'margin-left':'122px' } : {}
              " *ngIf="processList.status === 'finished'" (click)="activeProcessList(processList)">
              <mat-icon>autorenew</mat-icon>
              <span *ngIf="!(isSmallScreen$ | async)">Reativar processo seletivo</span>
            </button>
            <button style="margin-left: 10px" mat-stroked-button color="primary"
              (click)="OpenProcessListShare(processList)" matTooltip="Compatilhar esse processo seletivo"
              [disabled]="processList.status === 'finished' || (currentLead !== 'ACTIVE' && currentLead !== 'TRIAL')">
              <mat-icon>share</mat-icon>
              Compartilhar
            </button>
            <!-- <button style="margin-left: 10px" color="primary" mat-stroked-button (click)="creative()">
              <mat-icon>photo_library</mat-icon>
              Gerar criativo
            </button>
            <button style="margin-left: 10px" color="primary" mat-stroked-button (click)="imagePng()">
              <mat-icon>photo_library</mat-icon>
              Gerar PNG
            </button> -->
            <ng-container *ngIf="totalCandidatesToApproval > 0">
              <button mat-button color="accent" matTooltip="Candidatos para aprovação"
                (click)="openCandidatesToApproval(processList.id)">
                <mat-icon color="primary">rule</mat-icon>
                <span>{{ totalCandidatesToApproval }}</span>
              </button>
            </ng-container>
            <button class="right" color="primary" mat-stroked-button (click)="userProcessList(processList)" [ngStyle]="
                (isSmallScreen$ | async) &&
                ['new', 'pending'].includes(processList.status)
                  ? {
                      'margin-top': '10px',
                      'margin-right': '8px'
                    }
                  : (isSmallScreen$ | async) &&
                  processList.status === 'finished'
                  ? {
                      'margin-top': '15px',
                      'margin-right': '8px'
                    }
                  : {
                    'margin':'8px'
                  }
              ">
              <mat-icon>person_add</mat-icon>
              <span *ngIf="!(isSmallScreen$ | async)">Atribuir Usuário ao Processo Seletivo</span>
            </button>
          </div>

          <div class="process-list-panel" *ngIf="!(isSmallScreen$ | async)">
            <!-- <div style="flex: 1">
              <app-recruiter-search [currentProcessListId]="processList.id"
                [processStatus]="processList.status"></app-recruiter-search>
            </div> -->
            <div style="flex: 1; border-left: solid 1px #ccc">
              <app-create-process-list [currentProcessList]="processList"></app-create-process-list>
              <!--Precisa realmente atualizar a tela quando remove o candidato?-->
              <!-- <app-create-process-list (hireCandidatesEvent)="onHireCandidates()"
                [currentProcessList]="processList"
              ></app-create-process-list> -->
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
</div>